import React, { useEffect } from 'react';
import {
  bool, func, shape, string,
} from 'prop-types';
import {
  Form,
  FormField,
  Input,
} from './style';

export const ERROR_TEXT_INPUT_OTHER = 'Please enter a response in the "Other" text box';

const InputOtherDescription = (props) => {
  const {
    showInputOther, onChange, selectedValue, errorField,
  } = props;

  const handleChange = (e) => {
    onChange({ ...selectedValue, optionDescription: e.target.value });
  };

  useEffect(() => {
    if (!showInputOther) {
      const { optionDescription, ...rest } = selectedValue;
      onChange(rest);
    }
  }, [showInputOther]);

  return (
    <>
      {showInputOther && (
        <Form>
          <FormField
            control={Input}
            id="option-description"
            name="optionDescription"
            type="text"
            placeholder="Please type your response"
            onChange={handleChange}
            error={errorField}
          />
        </Form>
      )}
    </>
  );
};

InputOtherDescription.propTypes = {
  showInputOther: bool.isRequired,
  onChange: func.isRequired,
  selectedValue: shape({
    optionDescription: string,
  }).isRequired,
  errorField: bool,
};

InputOtherDescription.defaultProps = {
  errorField: false,
};

export default InputOtherDescription;
